<div class="eiq-section-progress">
  @if (label()) {
    <span class="eiq-section-progress__label text__md fw__400 caption">{{ label() }}</span>
  }

  <div class="eiq-section-progress__segments">
    @for (section of sections(); track $index) {
      <span
        class="eiq-section-progress__segments-item"
        [class.valid]="section.valid"
        [matTooltip]="section.tooltip ?? ''"
        [matTooltipDisabled]="!section.tooltip"
      ></span>
    }
  </div>
</div>
